export default {
  add(state, params) {
    state.count += params;
  },
  mini(state, params) {
    state.count -= params;
  },
  changeSchemaId(state, params) {
    state.schemaId = params;
  },
  serverTime(state, params) {
    state.serverTime = params;
  },
  session(state, params) {
    state.session = params;
    state.session = params;
  },
  meetingInfo(state, params) {
    state.meetingInfo = { ...params };
  },
  templateInfo(state, params) {
    state.templateInfo = { ...params };
  },
  setDocState(state, docState) {
    state.docState = docState;
  },
  setOffsetHide(state, offsetHide) {
    state.offsetHide = offsetHide;
  }
};
